import React, { useEffect, useState } from "react";
import { appAxios } from "../../../axios/axios";
import { IdeskPhone } from "../../../interfaces/enquiry.interface";
import { Form, Modal } from "react-bootstrap";
import { CustomInput } from "../../Common/Ui/CustomInput";
import { LoadingButton } from "../../Common/Ui/LoadingButton";
import { toast } from "react-toastify";
import { DeskphoneOptions } from "./DeskphoneOptions";
import { IDepartmentList } from "../../../interfaces/department.interface";
import { IUserData } from "../../../interfaces/userData.interface";
import { getSiteStaffList } from "../../../utils/User";

import deskphoneImg from "../../../asserts/images/deskphone-info.png";
import { ListSkeleton } from "../../Common/Ui/ListSkeleton";

export const Deskphone = () => {
  const [deskphoneList, setDeskphoneList] = useState<IdeskPhone[]>([]);
  const [showCreateDeskphone, setShowCreateDeskphone] = useState(false);
  const [createLoading, setCreateLoading] = useState(false);

  const [languageSwitch, setLanguageSwitch] = useState(false);
  const [listLoading, setListLoading] = useState(false);

  const [deskphoneInput, setDeskphoneInput] = useState<{
    name: string;
    number: string;
  }>({
    name: "",
    number: "",
  });

  const [departmentList, setDepartmentList] = useState<IDepartmentList[]>([]);
  const [staffList, setStaffList] = useState<IUserData[]>([]);

  const handleClose = () => setShowCreateDeskphone(false);
  const getSiteDeskphone = async () => {
    setListLoading(true);
    const deskphone = await appAxios.get("/staff/caller-desk/getAllDeskPhone");
    if (deskphone.data.success) {
      setDeskphoneList(deskphone.data.result);
    }

    setListLoading(false);
  };

  const createDeskphone = async () => {
    try {
      if (!deskphoneInput.name || !deskphoneInput.number) {
        toast.error("Name and Number are required");
        return;
      }
      setCreateLoading(true);
      const createResponse = await appAxios.post(
        "/staff/caller-desk/createDeskPhone",
        {
          deskphoneData: deskphoneInput,
        }
      );

      if (createResponse.data.success) {
        setShowCreateDeskphone(false);
        getSiteDeskphone();
        toast.success("Deskphone created successfully");
        setDeskphoneInput({
          name: "",
          number: "",
        });
      }
      setCreateLoading(false);
    } catch (error: any) {
      toast.error(error.data.errorMessage || "Unable to create deskphone");
      setCreateLoading(false);
    }
  };

  const getDepartment = async () => {
    const departmentRes = await appAxios.post(
      "/query-management-staff/getCrmDepartment"
    );

    if (departmentRes.data.success) {
      setDepartmentList(departmentRes.data.result);
    }
  };

  const getSiteStaff = async () => {
    const staffResponse = await getSiteStaffList();
    if (staffResponse.success) {
      setStaffList(staffResponse.result);
    }
  };

  useEffect(() => {
    getSiteDeskphone();
    getDepartment();
    getSiteStaff();
  }, []);
  return (
    <>
      <div className="container">
        {/* <Link className=" btn btn-sm back-btn" to={"/"}>
          <i className="fa-solid fa-chevron-left"></i>
          Go to list
        </Link> */}
        <div className="d-flex justify-content-between align-items-center my-3">
          <div className="fs-5 fw-bold text-muted">Manage Deskphone</div>
          <button
            className="btn btn-primary btn-sm my-1"
            onClick={() => {
              setShowCreateDeskphone(true);
            }}
          >
            + Deskphone
          </button>
        </div>
        <div>
          <div className="row my-4  align-items-center">
            <div className="col-lg-5 col-md-5 col-sm-12 col-12">
              <img
                className="img-fluid"
                src={deskphoneImg}
                alt="deskphone-image"
              />
            </div>
            <div className="col-lg-7 col-md-7 col-sm-12 col-12">
              <div className="d-flex justify-content-end mb-2">
                <label
                  htmlFor=""
                  className="small me-2"
                  onClick={() => {
                    setLanguageSwitch(false);
                  }}
                >
                  English
                </label>
                <Form.Check
                  type="switch"
                  className="small"
                  id="custom-switch"
                  checked={languageSwitch}
                  // label={`Read in ${languageSwitch ? "English" : "Hindi"}`}
                  onChange={
                    () => {
                      setLanguageSwitch(!languageSwitch);
                    }
                    // setLanguageSwitch((prevState) => !prevState)
                  }
                />
                <label
                  htmlFor=""
                  className="small ms-2"
                  onClick={() => {
                    setLanguageSwitch(true);
                  }}
                >
                  Hindi
                </label>
              </div>

              <div>
                <p className="small  text-muted">
                  {languageSwitch
                    ? "Caller Desk एक सॉफ़्टवेयर कंपनी है जो आपके फ़ोन कॉल्स को manage करने के लिए समाधान प्रदान करती है। आपके सभी कॉल्स caller desk द्वारा ट्रैक किए जा सकते हैं। अगर किसी कारण से कॉल का उत्तर नहीं दिया गया है, तो वह automatically हमारे CRM में लॉग किया जाएगा और उनके लिए एक callback request बन जाएगी।Caller desk आपको एक virtual नंबर (desk phone) प्रदान करेगी जो आपके कंपनी के किसी department या staff को सौंपा जा सकता है। इसके अलावा, call back request जो बनाए जाते हैं, वे department या staff को सौंपे जाते हैं जिनको desk phone (caller desk द्वारा प्रदान किया गया है) सौंपा गया है। जब कभी भी कॉल छूट जाती है या जवाब नहीं मिलता, तो हमारा CRM whatsapp पर एक department या staff को जिनको desk phone या virtual नंबर सौंपा गया है, उन्हें एक सूचना भेजेगा।अगर desk phone किसी department या staff को नहीं दिया गया है तो डिफ़ॉल्ट रूप से site admin को सूचना मिलेगी।"
                    : "Caller Desk is a software company that provides solutions to manage your phone calls. All of your calls can be tracked by the Caller Desk. If there are any unanswered calls, they will be automatically logged into our CRM and we will create a callback request for them. The caller desk will provide you a virtual number (Desk Phone) that can be assigned to any department or staff member of your company. Plus, call-back requests created will be assigned to the department or staff to which the desk phone is being allocated. Whenever a call is missed/unanswered, our CRM will send a notification on WhatsApp to the department head or staff to whom the Desk Phone/virtual number (provided by Caller Desk) is assigned. By default, the admin will receive a notification if the desk phone is not assigned to any department or staff."}
                </p>
              </div>
            </div>
          </div>

          {listLoading ? (
            <ListSkeleton count={2} />
          ) : (
            deskphoneList.map((deskphone, index) => {
              return (
                <div className="mb-3" key={`deskphone-${index}`}>
                  <div className="shadow-sm border p-3 bg-body rounded">
                    <div className="row">
                      <div className="col-lg-4">
                        <div className="small">
                          <span className="text-secondary"> Name : </span>
                          {deskphone.deskPhoneName}
                        </div>
                        <div className="m-0 small">
                          <span className="text-secondary">Deskphone : </span>
                          {deskphone.deskPhone}
                        </div>
                      </div>
                      <div className="col-lg-8">
                        {/* {staffList.length > 0 && departmentList.length > 0 && ( */}
                        <DeskphoneOptions
                          index={index}
                          deskphone={deskphone}
                          staffArr={staffList}
                          departmentArr={departmentList}
                        />
                        {/* )} */}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>

      <Modal show={showCreateDeskphone} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Create Deskphone</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CustomInput
            className="mb-3"
            label="Name"
            placeholder="Enter Name"
            onChange={(e) => {
              setDeskphoneInput((prev) => {
                return {
                  ...prev,
                  name: e.target.value,
                };
              });
            }}
            value={deskphoneInput.name}
          />
          <CustomInput
            className="mb-3 no-arrows"
            type="number"
            label="Deskphone"
            placeholder="Enter Number"
            onChange={(e) => {
              setDeskphoneInput((prev) => {
                return {
                  ...prev,
                  number: e.target.value,
                };
              });
            }}
            onWheel={(e) => {
              e.currentTarget.blur();
            }}
            value={deskphoneInput.number}
          />
        </Modal.Body>
        <Modal.Footer>
          <LoadingButton
            onClick={createDeskphone}
            children={"Create"}
            btnClass="btn btn-primary"
            loading={createLoading}
          />
        </Modal.Footer>
      </Modal>
    </>
  );
};
